/**
 * Help module — pilot orientation + About.
 *
 * Bill 2026-09-11. Deliberately a top-level module rather than a dialog: a
 * pilot user looking for help looks in the navigation, and the About panel is
 * the single best thing they can attach to a support request.
 */
import { Routes, Route, Navigate } from 'react-router';
import { HelpLanding } from './HelpLanding';

export function Help(): JSX.Element {
  return (
    <Routes>
      <Route index element={<HelpLanding />} />
      <Route path="about" element={<HelpLanding />} />
      <Route path="*" element={<Navigate to="/help" replace />} />
    </Routes>
  );
}

export default Help;
